(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitment-finder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-fitment-form]');
    if (!form) return;
    var parts = Array.from(form.querySelectorAll('[data-fitment-part]'))
      .map(function (input) { return input.value.trim(); })
      .filter(Boolean);
    form.querySelector('[data-fitment-query]').value = parts.join(' ');
  });

  } catch(e) { console.error(e); }
})();
})();
